import { keyValidator } from './key';
import { itemDataValidator } from './item-data';
import { requiredVariablesValidator } from './required-variables-validator';
export var buildCustomUrlValidators = function (_a) {
    var key = _a.key, itemData = _a.itemData;
    return [
        keyValidator(key),
        itemDataValidator(itemData),
        requiredVariablesValidator(key, itemData),
    ].find(Boolean);
};
//# sourceMappingURL=build-custom-url-validators.js.map